import React from "react";

interface ToggleProps {
  className?: string;
  show: boolean;
  toggle(): void;
}

const ToggleSwitch = (props: ToggleProps) => {
  const { className, toggle, show } = props;

  return (
    <div
      className={`flex items-center cursor-pointer ${
        show ? "bg-green-500" : "bg-gray-300"
      } relative w-12 h-6 rounded-full transition-colors duration-300 ${className}`}
      onClick={toggle}
    >
      <div
        className={`absolute w-6 h-6 bg-white border rounded-full shadow-md transform transition-transform duration-300 ease-in-out ${
          show ? "translate-x-6" : ""
        }`}
      ></div>
    </div>
  );
};

export default ToggleSwitch;
